(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 93);
/******/ })
/************************************************************************/
/******/ ({

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(94);


/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initGlassContext", function() { return initGlassContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGlassContext", function() { return getGlassContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeAppView", function() { return closeAppView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDevInstall", function() { return isDevInstall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openAppView", function() { return openAppView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showToast", function() { return showToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showContextMenu", function() { return showContextMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasCapability", function() { return hasCapability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getServices", function() { return getServices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCoreSvc", function() { return getCoreSvc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductLocale", function() { return getProductLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTimeZone", function() { return getTimeZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContentLocale", function() { return getContentLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTimeLocale", function() { return getTimeLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTextDirPref", function() { return getTextDirPref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentContent", function() { return getCurrentContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReadOnly", function() { return isReadOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "track", function() { return track; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadUserPreferences", function() { return loadUserPreferences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUserPreferences", function() { return updateUserPreferences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eventOn", function() { return eventOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eventOff", function() { return eventOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eventTrigger", function() { return eventTrigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addToMRU", function() { return addToMRU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMRUList", function() { return getMRUList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDataConnectionServiceFactory", function() { return getDataConnectionServiceFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleFeatureFlag", function() { return toggleFeatureFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFeatureEnabled", function() { return isFeatureEnabled; });
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common-components (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
let glassContext;

const getSvc = (...args) => glassContext.getSvc(...args);

const initGlassContext = context => glassContext = context;
const getGlassContext = () => glassContext;
const closeAppView = (...args) => glassContext.appController.closeAppView(...args);
const isDevInstall = () => glassContext.isDevInstall();
const openAppView = (...args) => glassContext.appController.openAppView(...args);
const showToast = (...args) => glassContext.appController.showToast(...args);
const showContextMenu = (...args) => glassContext.appController.showContextMenu(...args);
const hasCapability = (...args) => glassContext.hasCapability(...args);
const getServices = () => glassContext.services;
const getCoreSvc = (...args) => glassContext.getCoreSvc(...args);
function getProductLocale() {
  if (glassContext && glassContext.services && glassContext.services.userProfile && glassContext.services.userProfile.preferences && glassContext.services.userProfile.preferences.productLocale) {
    return glassContext.services.userProfile.preferences.productLocale;
  }

  return 'en'; // default
}
function getTimeZone() {
  if (glassContext && glassContext.services && glassContext.services.userProfile && glassContext.services.userProfile.preferences && glassContext.services.userProfile.preferences.timeZoneID) {
    return glassContext.services.userProfile.preferences.timeZoneID;
  }

  return 'Europe/London'; // default to get 'GMT' as default timeZone abbreviation
}
function getContentLocale() {
  if (glassContext && glassContext.services && glassContext.services.userProfile && glassContext.services.userProfile.preferences && glassContext.services.userProfile.preferences.contentLocale) {
    return glassContext.services.userProfile.preferences.contentLocale;
  }

  return 'en'; // default
}
function getTimeLocale() {
  return {
    contentLocale: getContentLocale(),
    timeZone: getTimeZone()
  };
}
function getTextDirPref() {
  if (glassContext && glassContext.services && glassContext.services.userProfile && glassContext.services.userProfile.preferences && glassContext.services.userProfile.preferences.baseTextDirection) {
    return glassContext.services.userProfile.preferences.baseTextDirection.toLowerCase();
  }

  return 'auto'; // default
}
function getCurrentContent() {
  if (glassContext && glassContext.appController && glassContext.appController.getCurrentContentView()) {
    return glassContext.appController.getCurrentContentView().getContent();
  }

  return {};
}
function isReadOnly() {
  const isDashboardReadOnly = !(!glassContext || !glassContext.appController || !(glassContext.appController.getCurrentContentView().isAuthoringMode === false || glassContext.appController.getCurrentContentView.isAuthoringMode === 'false'));
  return isDashboardReadOnly;
}
function track(analyticsData) {
  try {
    const instrumentation = getCoreSvc('.Instrumentation');

    if (instrumentation && instrumentation.enabled) {
      instrumentation.track(analyticsData);
    }
  } catch (e) {
    console.warn('There was an error attempting to track', e);
  }
}
function loadUserPreferences() {
  return glassContext.getSvc('.UserProfile').then(userProfileSvc => ({ ...userProfileSvc.preferences
  }));
}
function updateUserPreferences(data) {
  return getSvc('.UserProfile').then(userProfileSvc => {
    Object.assign(userProfileSvc.preferences, data);
    return userProfileSvc.savePreferences(userProfileSvc.preferences);
  });
}
function eventOn(...args) {
  return getSvc('.Events').then(eventSvc => eventSvc.on(...args));
}
function eventOff(...args) {
  return getSvc('.Events').then(eventSvc => eventSvc.off(...args));
}
function eventTrigger(...args) {
  return getSvc('.Events').then(eventSvc => eventSvc.trigger(...args));
}
function addToMRU(...args) {
  getSvc('.Content').then(contentSvc => {
    contentSvc.addToMRU(...args);
  });
}
function getMRUList() {
  return getSvc('.Content').then(contentSvc => contentSvc.getMRUList());
}
function getDataConnectionServiceFactory() {
  return getSvc('.DataConnectionServiceFactory');
}
function toggleFeatureFlag(feature, value = 'enabled') {
  getCoreSvc('.FeatureChecker').addRules({
    'ba-ui-common-components': {
      [feature]: value
    }
  });
}
function isFeatureEnabled(feature) {
  return getCoreSvc('.FeatureChecker').checkValue('ba-ui-common-components', feature, 'enabled');
}

/***/ })

/******/ });
});